import { useQuery } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useMyPaginatedPatients = (tenant, page = 1, search, rows = 10, enabled = true) => {

  return useQuery({
    queryKey: ["myPaginatedPatients", tenant, page, search, rows],
    enabled,
    queryFn: async () => {
      const axiosInstance = await createAxiosInstance();
      const response = await axiosInstance.get(
        search.length < 3
          ? `${tenant}/patient/mypatients/get`
          : `${tenant}/patient/mypatients/search/page/${search.replace(/\//g, '-')}`,
        {
          params: {
            page,
            rows,
          },
        }
      );
      return response.data;
    },
  });
};
